export const getCurrentAndOldDate = (difference) => {
    let currentDate = new Date();
    let oldDate = new Date(Date.parse(currentDate) - difference);
    currentDate = currentDate.toISOString();
    oldDate = oldDate.toISOString();
    return { currentDate, oldDate };
};
